import $ from 'jquery'
import get from 'lodash/get'
import swal from 'sweetalert2'

const warningMessage = get(window, ['APP', 'context', 'email_link_warning', 'message'], 'Continue to external link?')

function shouldInterceptClick(url) {
  if (!url) {
    return false
  }

  return url.indexOf('mailto') === 0
}

function warnOnEmailLinks() {
  $(document).on('click', 'a', (ev) => {
    const url = $(ev.currentTarget).attr('href')

    if (!shouldInterceptClick(url)) {
      return true
    }

    ev.preventDefault()

    swal({
      text: warningMessage,
      width: '24em',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#cacaca',
      confirmButtonText: 'Continue',
      animation: false,
      onOpen() {
        swal.getContent().style.fontSize = '.9rem'
      },
    }).then((result) => {
      if ('value' in result && result.value) {
        window.location = url
      }
    })

    return false
  })
}

export { warnOnEmailLinks }
